import { isDeepEqual, LogFancy, reduxConnectPipeline } from '../libraries/Helpers'
import TimerComponent from './TimerComponent'
import { actionModalHide, actionModalShow } from '../redux/modules/action'
import { selectCompletedToday } from '../redux/modules/node'


function mapStateToProps(state) {
    LogFancy.tag('mapStateToProps').print('Timer.mapStateToProps')

    const isLoaded = state.node.initialDataLoaded && !state.node.isFetching

    let rootId, rootNodeId, rightRootId, rightRootNodeId

    if (isLoaded) {
        rootId          = state.node.rootId
        rootNodeId      = state.node.rootNodeId
        rightRootId     = state.node.rightRootId
        rightRootNodeId = state.node.rightRootNodeId
    }

    return {
        rootId: rootId,
        rootNodeId: rootNodeId,
        rightRootId: rightRootId,
        rightRootNodeId: rightRootNodeId,
        isFetching: !isLoaded,
        showCompleted: state.node.showCompleted,
        completedToday: selectCompletedToday(state),
        isActionModalActive: state.action.isActive,
    }
}

function shouldUpdate(props, nextProps) {
    LogFancy.tag('shouldUpdate').blue('TimerComponent.shouldUpdate()')

    let isChanged = !isDeepEqual([
        props.isFetching,
        props.rootId,
        props.rightRootId,
        props.rightRootNodeId,
        props.completedToday,
        props.showCompleted,
        props.isActionModalActive,
    ], [
        nextProps.isFetching,
        nextProps.rootId,
        nextProps.rightRootId,
        nextProps.rightRootNodeId,
        nextProps.completedToday,
        nextProps.showCompleted,
        nextProps.isActionModalActive,
    ])

    if (isChanged) {
        console.log('TimerComponent.shouldComponentUpdate', isChanged)
    }

    return !isChanged
}

export default reduxConnectPipeline(
    TimerComponent,
    // areStatesEqual()
    (next, prev) => (
        next.node.initialDataLoaded === prev.node.initialDataLoaded &&
        next.node.isFetching === prev.node.isFetching &&
        next.node.rootId === prev.node.rootId &&
        next.node.rootNodeId === prev.node.rootNodeId &&
        next.node.rightRootNodeId === prev.node.rightRootNodeId &&
        next.node.showCompleted === prev.node.showCompleted &&
        next.node.initialDataLoaded === prev.node.initialDataLoaded &&
        next.action.isActive === prev.action.isActive
    ),
    mapStateToProps,
    {
        actionModalShow: actionModalShow,
        actionModalHide: actionModalHide,
    },
    shouldUpdate
)
